t = require('views/internal/teacup-with-helpers')('board_closed')

module.exports = t.renderable ({ name, deleting, canReopen, canDelete }) ->
  t.div '.big-message.quiet', ->
    t.h1 ->
      t.format 'name-is-closed', { name }

    if deleting
      t.format 'deleting'
    else
      if canReopen
        t.p ->
          t.a '.js-reopen', { href: '#' }, ->
            t.format 'reopen'

      if canDelete
        t.p { style: 'margin-top: 64px' }, ->
          t.a '.quiet.js-delete', { href: '#' }, ->
            t.format 'permanently-delete-board'

      if !canReopen && !canDelete
        t.p ->
          t.format 'you-re-a-member-of-this-board-but-only-board-admins-are-able-to-re-open-it'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_closed.coffee